import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Context
import { AuthProvider } from './context/AuthContext';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ClientDetail from './pages/ClientDetail';
import ClientForm from './pages/ClientForm';
import ClientEdit from './pages/ClientEdit';
import TwoFASetup from './pages/TwoFASetup';
import TwoFAVerify from './pages/TwoFAVerify';
import Profile from './pages/Profile';
import Subscription from './pages/Subscription';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import SubscriptionCancel from './pages/SubscriptionCancel';
import CGV from './pages/CGV';
import CGU from './pages/CGU';
import PrivacyPolicy from './pages/PrivacyPolicy';
import MentionsLegales from './pages/MentionsLegales';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Navbar />
          <main>
            <Routes>
              {/* Routes publiques */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/2fa/verify" element={<TwoFAVerify />} />
              
              {/* Routes de redirection Stripe (publiques mais sécurisées en interne) */}
              <Route path="/subscription/success" element={<SubscriptionSuccess />} />
              <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
              
              {/* Routes protégées */}
              <Route element={<ProtectedRoute />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/clients/new" element={<ClientForm />} />
                <Route path="/clients/:id" element={<ClientDetail />} />
                <Route path="/clients/:id/edit" element={<ClientEdit />} />
                <Route path="/2fa-setup" element={<TwoFASetup />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/subscription" element={<Subscription />} />
                <Route path="/clients" element={<Dashboard />} />
              </Route>
              
              {/* Redirection par défaut pour les routes inconnues */}
              {/* Pages légales */}
              <Route path="/cgv" element={<CGV />} />
              <Route path="/cgu" element={<CGU />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              
              {/* Redirection par défaut pour les routes inconnues */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
